import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import LottieLoader from "./lottie/lottie.jsx";

// Lazy load del TVChartContainer
const TVChartContainer = lazy(() =>
	import("./components/TVChartContainer/index").then((module) => ({
		default: module.default || module.TVChartContainer,
	}))
);

const App = () => {
	return (
		<Router>
			<ToastContainer />
			<Switch>
				<Route exact path="/">
					<Suspense fallback={<LoadingScreen />}>
						<TVChartContainer />
					</Suspense>
				</Route>
				<Route path="/chart">
					<Suspense fallback={<LoadingScreen />}>
						<TVChartContainer />
					</Suspense>
				</Route>
				<Redirect from="/login" to="/" />
				<Redirect from="/register" to="/" />
			</Switch>
		</Router>
	);
};

const LoadingScreen = () => (
	<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
		<LottieLoader />
	</div>
);

export default App;
